module.exports = __webpack_public_path__ + "images/emoji/card_index.bb24041ac245428d354b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/card_index.png
// module id = FO7J
// module chunks = 13